import { FaSkiing, FaSun, FaTimes } from "react-icons/fa";
import {
  Box,
  Button,
  Flex,
  Icon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import _ from "lodash";

import { Col, Row } from "../../../../components/paljs";
import { TooltipWrapper } from "../../../../components/tooltip";
import { CartDiscount, OrderItemDiscount } from "../../../../types";
import { WINTER_2027_PROFILE } from "../../../../utils/helpers";

import AdditionalInfo from "./additionalInfo";

type WinterOrderItemRowProps = {
  agreementUrl?: string;
  setTransport?: (transport: string) => void;
  transport?: string;
  id?: string;
  sport?: string;
  setSport?: (sport: string) => void;
  level?: string;
  setLevel?: (level: number) => void;
  profile?: string;
  price: string;
  location?: string;
  name?: string;
  periodName?: string;
  removeFromCart?: any;
  isOutOfStock?: boolean;
  isEditable?: boolean;
  setCampConsent?: (bool: boolean) => void;
  campConsent?: boolean;
  setInsuranceConsent?: (bool: boolean) => void;
  insuranceConsent?: boolean;
  setShirtSize?: (size: string) => void;
  shirtSize?: string;
  setHealthInfo?: (text: string) => void;
  healthInfo?: string;
  setRoommatesInfo?: (text: string) => void;
  roommatesInfo?: string;
  discount?: CartDiscount | OrderItemDiscount;
};
const WinterCampRow = ({
  agreementUrl,
  setTransport,
  transport,
  setSport,
  sport,
  setLevel,
  level,
  profile,
  price,
  name,
  periodName,
  location,
  id,
  removeFromCart,
  isOutOfStock,
  isEditable,
  setInsuranceConsent,
  insuranceConsent,
  setCampConsent,
  campConsent,
  setShirtSize,
  shirtSize,
  setHealthInfo,
  healthInfo,
  setRoommatesInfo,
  roommatesInfo,
  discount,
}: WinterOrderItemRowProps) => {
  const [isBigScreen] = useMediaQuery("(min-width: 1300px)");
  const [periodTitle, periodDatesWithoutFirstParenthesis] = _.split(
    periodName,
    "("
  );
  const periodDates = "(" + periodDatesWithoutFirstParenthesis;
  const showRemoveButton = (!!id && !!removeFromCart) || isOutOfStock;
  const isWinter2027 = profile === WINTER_2027_PROFILE;

  const showAdditionalInfo =
    setShirtSize &&
    setCampConsent &&
    setLevel &&
    setSport &&
    setHealthInfo &&
    setRoommatesInfo &&
    isEditable;

  return (
    <Box mb={3} padding={2} borderRadius={6}>
      <Row>
        <Col breakPoint={{ sm: isBigScreen ? 2 : 1 }}>
          <Flex align="center">
            {<Icon as={FaSkiing} mr={2} />}
            {isBigScreen &&
              (isWinter2027 ? "SKI & SNB Camp 2027" : "SKI&SNB Camp 2026")}
          </Flex>
        </Col>
        <Col breakPoint={{ sm: 2 }} className="elipsis">
          {isWinter2027
            ? null
            : profile === "Adventure Winter"
            ? "Adventure"
            : profile}
        </Col>
        <Col breakPoint={{ sm: isBigScreen ? 4 : 5 }}>{name ? name : null}</Col>
        <Col breakPoint={{ sm: 2 }}>
          {periodTitle}
          <br />
          {periodDates}
        </Col>
        <Col breakPoint={{ sm: 2 }} style={{ textAlign: "right" }}>
          {price}&nbsp;zł{" "}
          {showRemoveButton && (
            <>
              <Popover isOpen={isOutOfStock} placement="top">
                <PopoverTrigger>
                  <Button
                    size="xs"
                    onClick={() => removeFromCart(id)}
                    mr={2}
                    colorScheme={isOutOfStock ? "red" : undefined}
                  >
                    <Icon as={FaTimes} />
                  </Button>
                </PopoverTrigger>
                <PopoverContent
                  backgroundColor={isOutOfStock ? "pink" : undefined}
                >
                  <PopoverArrow
                    backgroundColor={isOutOfStock ? "pink" : undefined}
                  />
                  <PopoverBody>
                    Brak miejsc. Usuń produkt z koszyka.
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </>
          )}
          {!isEditable && discount && (
            <>
              <br />
              {/* The price above already includes the discount */}
              <b>w tym zniżka -{discount.discountValue.value} zł</b>{" "}
              {TooltipWrapper({ label: discount.reason })}
            </>
          )}
        </Col>
      </Row>
      {showAdditionalInfo && (
        <AdditionalInfo
          location={location}
          agreementUrl={agreementUrl}
          agreementName={
            isWinter2027
              ? "Warunkami Uczestnictwa SKI & SNB Camp 2027"
              : "Warunkami Uczestnictwa Campy Zima 2026"
          }
          setTransport={isWinter2027 ? setTransport : undefined}
          showShirtSize={!isWinter2027}
          transport={transport}
          setSport={setSport}
          sport={sport}
          setLevel={setLevel}
          level={level}
          setCampConsent={setCampConsent}
          campConsent={campConsent}
          setInsuranceConsent={setInsuranceConsent}
          insuranceConsent={insuranceConsent}
          setShirtSize={setShirtSize}
          shirtSize={shirtSize}
          setHealthInfo={setHealthInfo}
          healthInfo={healthInfo}
          setRoommatesInfo={setRoommatesInfo}
          roommatesInfo={roommatesInfo}
          isEditable={isEditable}
          discount={discount}
        />
      )}
    </Box>
  );
};

export default WinterCampRow;

export const WinterCampDisclaimer = () => (
  <Box mb={3} fontSize={"0.8rem"} color="grey">
    <Text as="i">Cena nie zawiera kosztów karnetu i wypożyczenia sprzętu.</Text>
    <br />
    <Text as="i">
      Środki na karnet i sprzęt należy przekazać opiekunowi na zbiórce w dniu
      wyjazdu na zgrupowanie.
    </Text>
  </Box>
);
